import React, { useState } from "react";
import { Link } from "react-router-dom";

// image
import logo from "../../images/logo.png";
import loginImage from "../../images/0.png";
const Login = ({ history }) => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState("");

  // const submitHandler = (e) => {
  //   e.preventDefault();

  //   history.push("/");
  // };
  const handleLogin = async (e) => {
    e.preventDefault();
    try {

      fetch("https://promaster.areez.co/auth/token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          params: {
            db: "PLO-v2",
            login: email,
            password: password,
          },
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.result && data.result.access_token) {
            localStorage.setItem("user", data.result.access_token);
            window.location.href = "/";
          } else {
            alert("Login failed");
          }
        })
        .catch((err) => {
          console.error("Login error:", err);
        });
    } catch (err) {
      console.error(err);
      setError("حدث خطأ أثناء الاتصال بالخادم.");
    }
  };

  return (
    <div className="container-fluid">
    <div className="row">
      
      <div className="col-md-6 d-none d-md-flex align-items-center justify-content-center p-0">
        <img
          src={loginImage}
          alt="Login Visual"
          style={{
            height: "100vh",
            width:"100%"
          }}
        />
      </div>
  
      <div className="col-md-6 d-flex align-items-center justify-content-center">
        <div className="w-75">
          <h4 className="text-center mb-4">تسجيل الدخول إلى حسابك</h4>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label><strong>البريد الإلكتروني</strong></label>
              <input
                type="text"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label><strong>كلمة السر</strong></label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="text-center mt-4">
              <button type="submit" className="btn btn btn-block" style={{background:"#304e50",color:"#fff"}}>
                تسجيل دخول
              </button>
            </div>
          </form>
        </div>
      </div>
      
    </div>
  </div>
  
  );
};

export default Login;
